import { useQuery } from 'react-query';
import getWorkingHours from 'data/requests/getWorkingHours';
import WorkingHours from 'model/workingHours';

const useWorkingHours = (brandId: string) => {
  const { data, isLoading, refetch } = useQuery<WorkingHours>(
    ['working-hours', brandId],
    () => getWorkingHours(brandId),
    { enabled: false },
  );

  return { workingHours: data, isLoading, refetch };
};

export default useWorkingHours;
